module.exports = __webpack_public_path__ + "static/profile-c33472a6f6aaec8c6e1cec1735660a2b.jpg";